__turbopack_context__.v({
  "gridItem": "styles-module__0uFviq__gridItem",
  "gridWrapper": "styles-module__0uFviq__gridWrapper",
});
